import React, { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Newsletter({ source = "footer", variant = "dark", className = "" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email, source);
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={`flex items-center border-b border-border ${className}`}>
      <input
        data-testid="newsletter-email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        className="flex-1 bg-transparent py-3 outline-none text-base placeholder:text-muted-foreground"
      />
      <button
        data-testid="newsletter-submit"
        type="submit"
        disabled={loading}
        className="p-2 text-primary hover:translate-x-1 transition-transform disabled:opacity-50"
        aria-label="Subscribe"
      >
        <ArrowRight className="w-5 h-5" />
      </button>
    </form>
  );
}
